export default "__VITE_ASSET__C2TM6YuS__"